import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getUsersInfo } from "../actions/user";
import { config } from "../config";
import loader from "../images/loader.svg";
import userIcon from "../images/user_icon.svg";
import logoutIcon from "../images/logout_icon.png";
class UserInfo extends Component {
  /**
   * Props
   *
   * @type {{isShowCompareCartWishLoader: RegExp, cartData: *}}
   */
  static props = {
    userInfo: PropTypes.array,
    isShowLoader: PropTypes.object,
  };

  componentDidMount() {
    this.props.getUserInfo();
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <div className={this.props.isShowLoader ? "" : "uk-hidden"}>
          <div className="loader-overlay uk-position-cover uk-position-z-index">
            <div className="uk-position-center">
              <img
                alt={""}
                className={"loader-overlay__img uk-width-small"}
                src={loader}
                uk-svg=""
              />
            </div>
          </div>
        </div>
        <div>

          {Object.keys(this.props.userInfo).length > 1 ? (
            <>
              <button className="header__login-link uk-visible@m" title={t('menu.enterToCabinet')} >
                <img alt={""} className="header__login-btn logout-icon" src={logoutIcon} />
              </button>
              <div uk-dropdown="mode: click; pos: bottom-right">
                <a
                  className="uk-link uk-link-reset"
                  href={config.apiUrl + "user/profile/"}
                >
                  {
                    this.props.userInfo.name +
                    " " +
                    this.props.userInfo.second_name}
                </a> 
                <span className="link-separator"> / </span>
                <a
                  className="uk-link uk-link-reset"
                  href={config.apiUrl + "logout/"}
                >
                  {t("userinfo.logout")}
                </a>
              </div>
              <div className="uk-flex uk-flex-middle uk-flex-between@l uk-hidden@m">
              <a
                  className="uk-link uk-link-reset"
                  href={config.apiUrl + "user/profile/"}
                >
                  {
                    this.props.userInfo.name +
                    " " +
                    this.props.userInfo.second_name}
                </a> 
                <span className="link-separator"> / </span>
                <a
                  className="uk-link uk-link-reset"
                  href={config.apiUrl + "logout/"}
                >
                  {t("userinfo.logout")}
                </a>
                </div>
            </>

          ) : (
            <>
              <button className="header__login-link uk-visible@m" title={t('menu.enterToCabinet')} >
                <img alt={""} className="header__login-btn" src={userIcon} uk-svg="" />
              </button>
              <div uk-dropdown="mode: click; pos: bottom-right">
                <div className="uk-flex uk-flex-middle uk-flex-between@l">
                  <a
                    className="uk-link uk-link-reset"
                    href={config.apiUrl + "login/"}
                  >
                    {t("menu.enterToCabinet")}
                  </a>
                  <span className="link-separator"> / </span>
                  <a className="uk-link uk-link-reset"
                    href={config.apiUrl + "register"}>{t("menu.regToCabinet")}</a>
                </div>
              </div>
              <div className="uk-flex uk-flex-middle uk-flex-between@l uk-hidden@m">
                  <a
                    className="uk-link uk-link-reset"
                    href={config.apiUrl + "login/"}
                  >
                    {t("menu.enterToCabinet")}
                  </a>
                  <span className="link-separator"> / </span>
                  <a className="uk-link uk-link-reset"
                    href={config.apiUrl + "register"}>{t("menu.regToCabinet")}</a>
                </div>
            </>

          )}
        </div>
      </>
    );
  }
}

const UserBar = withTranslation("translations")(UserInfo);

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getUserInfo: () => {
      dispatch(getUsersInfo());
    },
  };
};

const mapStateToProps = (store) => {
  const { userInfo, showUserLoader } = store.user;
  return {
    isShowLoader: showUserLoader,
    userInfo,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserBar);
